<template>
    <div class="q-pa-md" style="width: 320px">
      <p class="auth-menu-title">{{ t('title') }}</p>

      <div v-if="canCloseWindow">

        <p v-if="loginCodeOk">{{ t('loginCodeOk') }}</p>
        <p v-if="loginCodeError">{{ t('loginCodeError') }}</p>

        <div class="buttons q-mt-md">
          <q-btn outline no-caps
            icon="close"
            :label="t('closeWindow')"
            @click="closeWindow"
          />
        </div>
      </div>
      <div v-else-if="loadingCode">
        <q-spinner-tail size="2rem"/>
      </div>
      <div v-else>
        <div v-if="!$store.state.auth.username" class="no-login">
          <div>
            <q-form
              @submit="login"
              method="post"
            >
              <div v-if="$config.oauth.use2FA">
                {{ t('sessionNotStarted') }}
              </div>
              <div v-else>
                <q-input
                  dense
                  name="username"
                  v-model="credentials.username"
                  :placeholder="t('username')"
                  :rules="[ value => !!value || $t('validations.empty') ]"
                  :readonly="loading"
                  clearable
                  no-error-icon
                />
                <q-input
                  dense
                  name="password"
                  v-model="credentials.password"
                  type="password"
                  :placeholder="t('password')"
                  :readonly="loading"
                  clearable
                  no-error-icon
              />
              </div>
              <span
                v-if="invalidCredentials"
                class="text-negative"
              >
                {{ t('invalidCredentials') }}
              </span>
              <div class="q-pt-md">
                <q-btn color="grey-9" outline no-caps style="width: 100%"
                  type="submit"
                  icon="las la-user"
                  :loading="loading"
                >
                <div class="q-px-sm" style="font-weight: 300">{{ t('logIn') }}</div>
                </q-btn>
              </div>
            </q-form>
          </div>
        </div>

        <div v-else class="valid-login">
          <div class="row">
            <div class="col-2 q-ml-xs">
              <q-btn
                round outline
                size="md"
                :label="labelUser"
                disable
              />
            </div>
            <div class="col-9 q-pl-md">
              <div style="font-weight: 300">{{ t('authenticatedAs') }}: </div>
              <div style="font-weight: 500">{{ $store.state.auth.username }}</div>
            </div>
          </div>
          <div class="buttons q-mt-md">
            <q-btn
              v-if="adminUrl && isStaff"
              class="q-mb-sm"
              color="grey-9" outline no-caps style="width: 100%"
              icon="settings"
              type="a"
              :href="adminUrl"
              target="_blank"
            >
            <div class="q-px-sm" style="font-weight: 300">Administrador Geoportal</div>
            </q-btn>
            <q-btn color="grey-9" outline no-caps style="width: 100%"
              icon="exit_to_app"
              @click="logout"
            >
            <div class="q-px-sm" style="font-weight: 300">{{t('logOut')}}</div>
            </q-btn>
          </div>
          <div
            v-if="lastLogin"
            class="text-right text-grey-8 q-pr-xs q-mt-sm"
            style="font-weight: 300"
          >
            {{ t('lastLogin') }} {{ lastLogin }}
          </div>
          <div
            v-if="isStaff && $config.oauth.changePassword"
            class="text-right q-mr-xs q-mt-xs"
          >
            <a :href="$config.oauth.changePassword" target="_blank">
              {{ t('changePassword') }}
            </a>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
import axios from 'axios'
import { get } from 'lodash'
import { QBtn, QForm, QInput, QSpinnerTail } from 'quasar'

export default {
  name: 'AuthHeaderMenu',
  components: {
    QBtn,
    QForm,
    QInput,
    QSpinnerTail
  },
  data () {
    return {
      credentials: {
        username: this.$store.state.auth.username,
        password: ''
      },
      loading: false,
      loadingCode: false,
      canCloseWindow: false,
      loginCodeOk: false,
      loginCodeError: false,
      invalidCredentials: false
    }
  },
  computed: {
    adminUrl () {
      return get(this.$store.state.auth.profile, 'admin_url')
    },
    isStaff () {
      return get(this.$store.state.auth.profile, 'is_staff')
    },
    oauthType () {
      if (this.$config.oauth && this.$config.oauth.type) {
        return this.$config.oauth.type
      }
      return ''
    },
    labelUser () {
      return this.$store.state.auth.username && this.$store.state.auth.username.slice(0, 2).toUpperCase()
    },
    lastLogin () {
      return this.$store.state.auth.lastLogin
    }
  },
  mounted () {
    this.invalidCredentials = false
  },
  methods: {
    logout () {
      if (this.$config.oauth.use2FA) {
        this.logout2FA()
      } else {
        this.credentialsLogout()
      }
    },
    credentialsLogout () {
      this.$store.dispatch('auth/logout').catch(this.$except)
    },
    logout2FA () {
      const href = `${this.$config.mapiaServer}account/logout/`
      const name = 'Autenticació d\'usuari'
      const loginPopup = window.open(href, name, 'height=1,width=1')
      loginPopup.focus()
      const $store = this.$store
      window.addEventListener('message', function (msg) {
        if (msg.data && msg.data.type === 'serverLogout') {
          $store.dispatch('auth/logout').catch(this.$except)
          loginPopup.close()
        }
      })
    },
    observeAuth () {
      this.$store.dispatch('auth/observeAuth', { seconds: 120 })
    },
    login () {
      if (this.$config.oauth.use2FA) {
        this.login2FA()
      } else {
        this.credentialsLogin()
      }
    },
    credentialsLogin () {
      this.loading = true
      this.$store.dispatch('auth/credentialsLogin', this.credentials)
        .then(() => {
          this.invalidCredentials = false
          this.credentials.password = ''
          this.loading = false
        })
        .then(() => {
          if (this.$config.oauth.userTracking && this.$store.state.auth.username) {
            let headers = this.$store.getters['auth/headers']
            axios.post(this.$config.oauth.userTracking, {}, { headers })
          }
        })
        .catch(({ invalidCredentials }) => {
          if (invalidCredentials) {
            this.invalidCredentials = true
          }
          this.loading = false
        })
    },
    login2FA () {
      const href = `${this.$config.mapiaServer}account/login/?next=callback/`
      const name = 'Autenticació d\'usuari'
      const loginPopup = window.open(href, name, 'height=600,width=500,resizable=yes,scrollbars=yes')
      loginPopup.focus()
      const $store = this.$store
      window.addEventListener('message', function (msg) {
        if (msg.data && msg.data.type === 'serverLogin') {
          $store.commit('auth/setUsername', msg.data.username)
          $store.commit('auth/setAccessToken', msg.data.access_token)
          $store.dispatch('auth/saveState')
          $store.dispatch('auth/updateUserInfo')
          loginPopup.close()
        }
      })
    },
    t (key) {
      return this.$t('tools.auth.' + key)
    }
  }
}
</script>

<style lang="scss">
.auth-menu-title {
  font-size: 1.2em;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  margin-bottom: 10px;
}
.auth-panel {
  .buttons {
    display: flex;
    justify-content: flex-end;

    a {
      color: black;
    }
  }

  .valid-login {
    .username {
      font-weight: bold;
    }
  }
}
</style>
